import {
    RESET_STATE,

    LISTAGEM_FATURAMENTO_LOADING,
    LISTAGEM_FATURAMENTO,
    LISTAGEM_FATURAMENTO_ERRO,

    LISTAGEM_DETALHAMENTO_FATURAMENTO_LOADING,
    LISTAGEM_DETALHAMENTO_FATURAMENTO,
    LISTAGEM_DETALHAMENTO_FATURAMENTO_ERRO,

    DETALHAMENTO_FATURAMENTO_LOADING,
    DETALHAMENTO_FATURAMENTO,
    DETALHAMENTO_FATURAMENTO_ERRO
} from '../types/FaturamentoType';

const initialState = {
    listagem_faturamento_loading: null,
    listagem_faturamento: null,
    listagem_faturamento_erro: null,

    listagem_detalhamento_faturamento_loading: null,
    listagem_detalhamento_faturamento: null,
    listagem_detalhamento_faturamento_erro: null,

    detalhamento_faturamento_loading: null,
    detalhamento_faturamento_erro: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case RESET_STATE:
            return initialState;
        case LISTAGEM_FATURAMENTO_LOADING:
            return {
                ...state,
                listagem_faturamento_loading: action.payload
            }
        case LISTAGEM_FATURAMENTO:
            return {
                ...state,
                listagem_faturamento_loading: false,
                listagem_faturamento: action.payload,
                listagem_faturamento_erro: null
            }
        case LISTAGEM_FATURAMENTO_ERRO:
            return {
                ...state,
                listagem_faturamento_loading: false,
                listagem_faturamento_erro: action.payload
            }
        case LISTAGEM_DETALHAMENTO_FATURAMENTO_LOADING:
            return {
                ...state,
                listagem_detalhamento_faturamento_loading: action.payload
            }
        case LISTAGEM_DETALHAMENTO_FATURAMENTO:
            return {
                ...state,
                listagem_detalhamento_faturamento_loading: false,
                listagem_detalhamento_faturamento: action.payload,
                listagem_detalhamento_faturamento_erro: null
            }
        case LISTAGEM_DETALHAMENTO_FATURAMENTO_ERRO:
            return {
                ...state,
                listagem_detalhamento_faturamento_loading: false,
                listagem_detalhamento_faturamento_erro: action.payload
            }
        case DETALHAMENTO_FATURAMENTO_LOADING:
            return {
                ...state,
                detalhamento_faturamento_loading: action.payload
            }
        case DETALHAMENTO_FATURAMENTO:
            const { ano, mes, faturamento } = action.payload;
            const lista = state.listagem_detalhamento_faturamento.slice();

            lista.filter(x => x.ano === ano && x.mes === mes)[0].detalhamento = faturamento;

            return {
                ...state,
                detalhamento_faturamento_loading: false,
                listagem_detalhamento_faturamento: lista,
                detalhamento_faturamento_erro: null
            }
        case DETALHAMENTO_FATURAMENTO_ERRO:
            return {
                ...state,
                detalhamento_faturamento_loading: false,
                detalhamento_faturamento_erro: action.payload
            }
        default:
            return state;
    }
}